const MAX_VALUE = 2147483647;

export const getSearchTime = (timestamp: number) => {
  const searchTime = Date.now() - timestamp;

  return searchTime > 0 && searchTime <= MAX_VALUE ? searchTime : 0;
};
